let showToastHandler;

export const registerToast = (fn) => {
  showToastHandler = fn;
};

export const toast = {
  success: (message) => showToastHandler(message, "success"),
  error: (message) => showToastHandler(message, "danger"),
  warning: (message) => showToastHandler(message, "warning"),
  info: (message) => showToastHandler(message, "info"),
};